'use client';
import { useIsMobile } from '@/hooks/use-is-mobile';
import Image from 'next/image';

export const OurStory = () => {
  const { isMobile } = useIsMobile();
  const imgSrc = isMobile ? '/about-us/our-story_m.png' : '/about-us/our-story.png';
  return (
    <div className='w-full'>
      <div className='container mx-auto items-start justify-between bg-[#F9F9F9] lg_flex'>
        <h2 className='h-[60px] pl-[12px] text-left font-teko-medium text-[30px] uppercase leading-[60px] lg_hidden'>
          Our Story
        </h2>
        <Image
          src={imgSrc}
          alt='about-us-new-page'
          width={720}
          height={450}
          className='w-full object-cover'
        />
        <div className='h-full px-[12px] py-[20px] lg_p-[40px]'>
          <h2 className='hidden text-left font-teko-medium text-[40px] uppercase leading-[48px] lg_mb-[20px] lg_block  lg_text-[40px]'>
            Our Story
          </h2>
          <p className='mb-[10px] font-roboto-regular text-[16px] leading-[24px] lg_mb-[30px] lg_text-[18px] lg_leading-[30px]'>
            At Hisea, we believe that the best adventures begin when you step outside. Hisea was founded on a passion
            for the outdoors and a commitment to quality, and we set out to create footwear that keeps up with your
            lifestyle—no matter where your journey takes you.
          </p>
          <p className=' font-roboto-regular text-[16px] leading-[24px] lg_text-[18px] lg_leading-[30px]'>
            From humble beginnings, we have grown into a trusted brand, providing durable, comfortable, and reliable
            waterproof boots for outdoor enthusiasts around the world. Whether you're hunting in the backwoods, fishing
            by the river, working on the farm, or exploring the snowy mountains, Hisea is by your side, keeping your
            feet dry and warm.
          </p>
        </div>
      </div>
    </div>
  );
};
